export enum OutputDimentionScale {
  AUTO = "Auto",
  FIXED_SIZE = "Fixed Size",
}

export default OutputDimentionScale;
